import $ from 'jquery';
import Platform from './module-platform';
import { ROOSTERMONEY_TWITTER_HANDLE, SOCIAL_SHARING } from 'js/constants/social-constants';
import { ALERT_EVENTS, ALERT_TYPES } from 'js/constants/alert-constants';
const ACTIVE_CLASS = 'is-active';

class SocialShare {
  constructor($el) {
    this.$el = $el;

    const $toggle = this.$el.find('[data-toggle]');

    this.$el.find('[data-id]').on('click', (ev) => this.onClickShare(ev));

    if (Platform.isDesktop()) {
      $el.hover((ev) => this.toggleContainer(ev));
    } else {
      $toggle.on('click', (ev) => this.toggleContainer(ev));
    }
  }

  constructShareUrl(type) {
    const url = window.location.href.split('?')[0];
    const title = $('[data-title]').text();
    const body = $("meta[property='og:description']").attr('content');
    const formattedUrl = this.formatShareUrl(url, type, title);
    const content = {
      ...(title && { title }),
      ...(body && { body }),
      url: formattedUrl,
    };

    switch (type) {
      case SOCIAL_SHARING.FACEBOOK:
        return this.constructFacebookUrl(content.url);
      case SOCIAL_SHARING.TWITTER:
        return this.constructTwitterUrl(content);
      case SOCIAL_SHARING.EMAIL:
        return this.constructEmailUrl(content);
      default:
        return formattedUrl;
    }
  }

  constructTwitterUrl(content) {
    const { url, body } = content;
    const params = new URLSearchParams({
      url,
      ...(body && { text: body }),
      via: ROOSTERMONEY_TWITTER_HANDLE,
      hashtags: 'financialeducation,pocketmoney,pocketmoneysorted,',
    });

    return `https://twitter.com/intent/tweet?${params.toString()}`;
  }

  constructFacebookUrl(url) {
    return `https://www.facebook.com/sharer.php?u=${url}`;
  }

  constructEmailUrl(content) {
    const params = new URLSearchParams({
      ...(content.title && { subject: content.title }),
      ...(content.body && { body: content.body }),
    });
    const paramsString = params.toString();

    return `mailto:${paramsString.length ? `${paramsString} by` : ''} @roostermoney ${content.url}`;
  }

  formatShareUrl(url, type, title) {
    const params = new URLSearchParams({
      ...(title && { utm_campaign: title.replace(/\s+/g, '-').toLowerCase() }),
      source: type,
      utm_medium: 'blog_share',
    });

    return encodeURIComponent(`${url}?${params.toString()}`);
  }

  onClickShare(ev) {
    ev.preventDefault();

    const type = $(ev.currentTarget).data('id');
    const url = this.constructShareUrl(type);

    if (type === SOCIAL_SHARING.COPY_URL) {
      this.copyUrl(url);
    } else if (type === SOCIAL_SHARING.EMAIL) {
      window.open(url);
    } else {
      this.openShareWindow(url);
    }
  }

  copyUrl(url) {
    const event = new CustomEvent(ALERT_EVENTS.SHOW, {
      detail: {
        theme: ALERT_TYPES.SUCCESS,
        text: 'Copied To Clipboard',
      },
    });
    const ele = document.querySelector('body');

    navigator.clipboard.writeText(url);
    ele.dispatchEvent(event);
  }

  toggleContainer(ev) {
    ev.preventDefault();

    this.$el.toggleClass(ACTIVE_CLASS);
  }

  setActiveClass(ev) {
    ev.preventDefault();

    this.$el.addClass(ACTIVE_CLASS);
  }

  removeActiveClass(ev) {
    ev.preventDefault();

    this.$el.removeClass(ACTIVE_CLASS);
  }

  openShareWindow(url) {
    // eslint-disable-next-line no-magic-numbers
    const left = (screen.width - 570) / 2;
    // eslint-disable-next-line no-magic-numbers
    const top = (screen.height - 570) / 2;
    const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;

    window.open(url, 'NewWindow', params);
  }
}

export default SocialShare;
